import {
  deleteSchedulerStatusModelGroup,
  deleteSchedulerStatusModels,
  getSchedulerStatusModelGroup,
  getSchedulerStatusModels,
  setSchedulerStatusModelGroup,
  setSchedulerStatusModels
} from '../storage.service';

export class SchedulerStatusModelsKeyService {
  get schedulerStatusModelsKey() {
    return getSchedulerStatusModels;
  }

  get schedulerStatusModelGroupKey() {
    return getSchedulerStatusModelGroup;
  }

  setSchedulerStatusModelsKey(schedulerStatusModelsKeyValue: any) {
    setSchedulerStatusModels(schedulerStatusModelsKeyValue);
  }

  setSchedulerStatusModelGroupKey(schedulerStatusModelGroupKeyValue: any) {
    setSchedulerStatusModelGroup(schedulerStatusModelGroupKeyValue);
  }

  removeSchedulerStatusModelsKeys() {
    deleteSchedulerStatusModels();
  }

  removeSchedulerStatusModelGroupKey() {
    deleteSchedulerStatusModelGroup();
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/visual/schedulerStatusModelsKey.service.ts